import http from '@/api/http'
let modules = require.context('./modules', false, /([A-Z]|\w+)\.(js)$/)
let serviceObj = {}
modules.keys().forEach((item, index) => {
  let modulesItem = modules(item).default
  for (let key in modulesItem) {
    serviceObj[key] = (params) => {
      let api = key.replace(/_/g, '/')
      return http[modulesItem[key].type](api, params)
    }
  }
})
export default serviceObj



// WEBPACK FOOTER //
// ./src/service/index.js